/** 
*@author: Sirisha.M
*@Description : 
**/
import _ from 'lodash';
import dayjs from 'dayjs';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import SubEquipments from './SubEquipments';
import { constant } from '../Utils/constants';
// import translation from '../Utils/translation';
import translation from '../Utils/translation';
import Highlighter from 'react-highlight-words';
import { connect } from 'react-redux';
import InputComponent from '../Utils/InputComponent';
import localStorage from '../../../utils/localStorage';
import SelectComponent from '../Utils/SelectComponent';
import StyledTable from '../../../commons/styles/table';
import { IPAddress, UPLOAD } from '../../../commons/api';
import themeSettings from '../../../commons/styles/themeSettings.json';
import {
  DownloadOutlined,
  UploadOutlined,
  SearchOutlined
} from '@ant-design/icons';
import {
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Select,
  Space,
  Tabs,
  Upload,
  Divider,
  TreeSelect
} from 'antd';
import {
  getDeviceDetailsById,
  getDeviceTypeList,
  saveDevice,
  saveParameter,
  getAttributeList,
  getParameterData,
  getSubEquipmentListWithParent,
  getParameterFileDownloadNameAPI,
  getPriorityList
} from '../APICalls';

const Device = (props) => {
  const [activeKey, setActiveKey] = useState('Device');
  const [formObject, setFormObject] = useState({});
  const [attributeList, setAttributeList] = useState([]);
  const [parameterList, setParameterList] = useState([]);
  const [DuplicateList, setDuplicateList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subequipmentListWithParent, setSubequipmentListWithParent] = useState({});
  const [deviceTypeList, setDeviceTypeList] = useState([]);
  const [priorityList, setPriorityList] = useState([]);
  const [treeValue, setTreeValue] = useState('');
  const [searchText, setSearchText] = useState('');
  const [parameterFileName, setParameterFileName] = useState('');
  const [deviceType, setDeviceType] = useState(null);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  // const [record, setRecord] = useState({});
  const searchInput = useRef(null);

  const hRef = useRef();

  useEffect(() => {
    setData(props.ShowForm);
    GetDeviceType(props.Module);
    // this.saveRow();
  }, []);

  useEffect(() => {
    // if (
    //   props.ShowForm !== props.ShowForm ||
    //   props.selectedRow !== props.selectedRow
    // ) {
    setData(props.ShowForm);
    // }
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.ShowForm, props.selectedRow]);

  const GetDeviceType = async (module) => {
    let deviceTypeListResponse = await getDeviceTypeList(module);
    let priorityListResponse = await getPriorityList();
    setDeviceTypeList(deviceTypeListResponse);
    setPriorityList(priorityListResponse);
  };

  const setData = async (ShowForm) => {
    if (ShowForm === 'Device' || ShowForm === 'ADD_DEVICE') {
      let { selectedRow } = props;
      if (selectedRow && selectedRow.Type === 'DeviceType') {
        let formData = {
          DeviceType: selectedRow.Code
        };
        let attributeListResponse = await getAttributeList(selectedRow.Code);
        const attKeys = {};
        attributeListResponse.forEach(({ Code }) => Object.assign(attKeys, { [Code]: null }));

        hRef.current &&
          hRef.current.setFieldsValue({
            DeviceType: null,
            Name: null,
            Description: null,
            UniqueCode: null,
            DisplayCode: null,
            Id: null,
            ...attKeys
          });
        hRef.current && hRef.current.setFieldsValue({ ...formData });
        setFormObject(formData);
        setAttributeList(attributeListResponse);
        setActiveKey('Device');
      } else {
        hRef.current &&
          hRef.current.setFieldsValue({
            DeviceType: null,
            Name: null,
            Description: null,
            DisplayCode: null,
            UniqueCode: null,
            InstallationDate: null,
            ReplacementDate: null,
            SerialNo: null,
            UnitName: null,
            Id: null
          });
        setFormObject({});
        setAttributeList([]);
        setActiveKey('Device');
      }
    } else if (ShowForm === 'EDIT_DEVICE') {
      let { selectedRow } = props;
      if (selectedRow.Code) {
        equipmentParentNChildEquipment(selectedRow.Code);
        let formObjectResponse = await getDeviceDetailsById(selectedRow.Code, 'AliasCode');
        _.cloneDeepWith(formObjectResponse, (value) => {
          return value &&
            value !== null &&
            typeof value === 'object' &&
            (value.ReplacementDate || value.InstallationDate || value.INSTALLATIONDATE || value.REPLACEMENTDATE)
            ? {
              ...(value['ReplacementDate�']
                ? (value['ReplacementDate�'] = dayjs.utc(
                  value['ReplacementDate�'],
                  'YYYY-MM-DD HH:mm:ss'
                ))
                : null),
              ...(value['InstallationDate']
                ? (value['InstallationDate'] = dayjs.utc(
                  value.InstallationDate,
                  'YYYY-MM-DD HH:mm:ss'
                ))
                : null),
              ...(value['ReplacementDate']
                ? (value['ReplacementDate'] = dayjs.utc(
                  value.ReplacementDate,
                  'YYYY-MM-DD HH:mm:ss'
                ))
                : null),
              ...(value['INSTALLATIONDATE']
                ? (value['INSTALLATIONDATE'] = dayjs.utc(
                  value.INSTALLATIONDATE,
                  'YYYY-MM-DD HH:mm:ss'
                ))
                : null),
              ...(value['REPLACEMENTDATE']
                ? (value['REPLACEMENTDATE'] = dayjs.utc(
                  value.REPLACEMENTDATE,
                  'YYYY-MM-DD HH:mm:ss'
                ))
                : null),
              ...(value['CreatedTime']
                ? (value['CreatedTime'] = dayjs.utc(value.CreatedTime, 'YYYY-MM-DD HH:mm:ss'))
                : null)
            }
            : _.noop();
        });

        let formData = formObjectResponse && formObjectResponse[0] ? formObjectResponse[0] : {};
        let updatedObject = {
          ...formData,
          UniqueCode: formData && formData.DeviceCode
        };
        let attributeListResponse = await getAttributeList(formData.DeviceType);
        hRef.current && hRef.current.setFieldsValue({ ...updatedObject });
        let { parent } = props;
        getParameterFileDownloadName(parent.Code, selectedRow.Code);
        setFormObject(updatedObject);
        setAttributeList(attributeListResponse);
        setActiveKey('Device');
        setTreeValue(selectedRow.Code);

        getParameterList(selectedRow.Code, updatedObject);
      } else {
        message.error('DeviceCode is missing in hierarchy structure');
      }
    }
  };


  const onFieldChange = async (fieldValue, fieldName) => {
    if (fieldName === 'DeviceType') {
      let attributeListResponse = await getAttributeList(fieldValue);
      setAttributeList(attributeListResponse);
    }

    setFormObject((prev) => ({
      ...prev,
      [fieldName]: fieldValue
    }));
  };

  const onReset = () => {
    const attKeys = {};
    attributeList.forEach(({ Code }) => Object.assign(attKeys, { [Code]: null }));

    hRef.current &&
      hRef.current.setFieldsValue({
        DeviceType: null,
        Name: null,
        Description: null,
        DisplayCode: null,
        UniqueCode: null,
        Id: null,
        ...attKeys
      });

    setFormObject({});
    setAttributeList([]);
  };

  const onCreate = async () => {
    let { selectedRow, parent } = props;
    const siteId = localStorage.get('currentSite');

    hRef.current
      .validateFields()
      .then(async (values) => {
        values = {
          ...hRef.current.getFieldsValue()
        };

        let payload;

        if (values.Id) {
          payload = {
            ...values,
            EquipmentType: 'Parent',
            ParentEquipment: null,
            AssetAlias: formObject && formObject.AssetAlias ? formObject.AssetAlias : '',
            SubDeviceType: null
          };
        } else {
          payload = {
            ...values,
            DeviceType: selectedRow.Type === 'DeviceType' ? selectedRow.Code : values.DeviceType,
            SiteId: siteId,
            EquipmentType: 'Parent',
            AssetAlias: selectedRow.Type === 'DeviceType' ? parent.Code : selectedRow.Code,
            ParentEquipment: null
          };
        }

        if (!payload.Id) delete payload.Id;

        let saveResponse = await saveDevice(payload);

        if (saveResponse && saveResponse.message) {
          message.success(saveResponse.message);

          let formObjectResponse = await getDeviceDetailsById(saveResponse.AliasCode, 'AliasCode');

          _.cloneDeepWith(formObjectResponse, (value) => {
            return value &&
              value !== null &&
              typeof value === 'object' &&
              (value.ReplacementDate || value.InstallationDate || value.INSTALLATIONDATE || value.REPLACEMENTDATE)
              ? {
                ...(value['ReplacementDate�']
                  ? (value['ReplacementDate�'] = dayjs.utc(
                    value['ReplacementDate�'],
                    'YYYY-MM-DD HH:mm:ss'
                  ))
                  : null),
                ...(value['InstallationDate']
                  ? (value['InstallationDate'] = dayjs.utc(
                    value.InstallationDate,
                    'YYYY-MM-DD HH:mm:ss'
                  ))
                  : null),
                ...(value['ReplacementDate']
                  ? (value['ReplacementDate'] = dayjs.utc(
                    value.ReplacementDate,
                    'YYYY-MM-DD HH:mm:ss'
                  ))
                  : null),
                ...(value['INSTALLATIONDATE']
                  ? (value['INSTALLATIONDATE'] = dayjs.utc(
                    value.INSTALLATIONDATE,
                    'YYYY-MM-DD HH:mm:ss'
                  ))
                  : null),
                ...(value['REPLACEMENTDATE']
                  ? (value['REPLACEMENTDATE'] = dayjs.utc(
                    value.REPLACEMENTDATE,
                    'YYYY-MM-DD HH:mm:ss'
                  ))
                  : null),
                ...(value['CreatedTime']
                  ? (value['CreatedTime'] = dayjs.utc(value.CreatedTime, 'YYYY-MM-DD HH:mm:ss'))
                  : null)
              }
              : _.noop();
          });

          let formData = formObjectResponse && formObjectResponse[0] ? formObjectResponse[0] : {};
          getParameterList(selectedRow.Code, formData);
          let updatedObject = {
            ...formData,
            UniqueCode: formData.UniqueCode
          };
          props.GetHierarchyLevelsUpdated();

          hRef.current.setFieldsValue(updatedObject);
          setFormObject(updatedObject);
        }
      })
      .catch((e) => {
        console.error("Error faced", e);
      });
  };

  const getParameterList = async (DeviceAlias, formData, deviceType) => {

    let parameterListResponse = [];
    let DuplicateListResponse = [];
    if (deviceType && deviceType !== undefined) {
      parameterListResponse = await getParameterData(deviceType, DeviceAlias);
      DuplicateListResponse = await getParameterData(deviceType, DeviceAlias);
    } else {
      parameterListResponse = await getParameterData(formData.DeviceType, DeviceAlias);
      DuplicateListResponse = await getParameterData(formData.DeviceType, DeviceAlias);
    }

    // let newObj={};
    parameterListResponse &&
      Array.isArray(parameterListResponse) &&
      parameterListResponse.map((record) => {
        record['Editable'] = 'false';
        return {};
      });
    DuplicateListResponse &&
      Array.isArray(DuplicateListResponse) &&
      DuplicateListResponse.map((record) => {
        record['Editable'] = 'false';
        return {};
      });
    setParameterList(parameterListResponse);
    setDuplicateList(DuplicateListResponse);
  };

  const updateParentDataFromSUbEqpChange = () => {
    let { selectedRow } = props;
    equipmentParentNChildEquipment(selectedRow.Code);
  };

  const equipmentParentNChildEquipment = async (DeviceAlias) => {
    let subequipmentWithParentResponse = await getSubEquipmentListWithParent(DeviceAlias);
    setSubequipmentListWithParent(subequipmentWithParentResponse);
  };

  const getParameterFileDownloadName = async (DeviceType, DeviceAlias, deviceType) => {
    let parameterFileNameResponse = null;
    if (deviceType && deviceType !== undefined) {
      parameterFileNameResponse = await getParameterFileDownloadNameAPI(deviceType, DeviceAlias);
    } else {
      parameterFileNameResponse = await getParameterFileDownloadNameAPI(DeviceType, DeviceAlias);
    }

    setParameterFileName(parameterFileNameResponse && parameterFileNameResponse.file ? parameterFileNameResponse.file : '');
  };

  const editRow = (key) => {
    const DuplicateList = parameterList;
    const updatedList = parameterList.map((item) => {
      if (item.Code === key) {
        return { ...item, Editable: 'true' };
      }
      return item;
    });
    setParameterList(updatedList);
    setDuplicateList(DuplicateList);
    // setSlectedRow(key);
  };
  const handleKeyPress = (e, recordKey) => {
    if (e.key === 'Enter') {
      const record = parameterList.find((item) => item.Code === recordKey);
      if (record) saveRow(record);
    }
  };

  const saveRow = async (record) => {
    let { selectedRow, parent } = props;
    setLoading(true);
    let payload = {
      ...record,
      DeviceAlias: selectedRow && selectedRow.Code
    };

    let t1 = await saveParameter({ ...payload, DeviceAlias: treeValue });
    message.success(t1 && t1.message);

    const deviceType = findDeviceType(subequipmentListWithParent, treeValue);

    let uot = getParameterList(treeValue, formObject, deviceType);
    getParameterFileDownloadName(parent.Code, selectedRow.Code, deviceType);



    // let uot = getParameterList(treeValue, formObject);
    // getParameterFileDownloadName(parent.Code, selectedRow.Code);

    if (uot) {
      record['Editable'] = 'false';
      setLoading(false);
      setParameterList(uot);
    }
  };
  // const getRowByKey = (key, newData) => {
  //   const { parameterList } = parameterList;
  //   return (newData || parameterList).filter((item) => item.id === key)[0];
  // };

  const handleFieldChange = (value, fieldName, recordKey) => {

    // const DuplicateList = parametersList;
    const updatedList = parameterList.map((item) => {
      if (item.Code === recordKey) {
        return { ...item, [fieldName]: value };
      }
      return item;
    });
    setParameterList(updatedList);
    // setDuplicateList(DuplicateList);
  };
  const renderWidget = (props) => {
    let { widget, Code, isEditableOnUpdate, JSON, Name } = props;
    let deviceType =
      hRef && hRef.current && hRef.current.getFieldValue('DeviceType');
    switch (widget) {
      case 'text':
        return (
          <InputComponent
            value={
              formObject && formObject[Code]
                ? translation(translationCache, formObject[Code])
                : ''
            }
            placeholder={`Input ${Name}`}
            disabled={formObject.Id && isEditableOnUpdate === 'true' ? true : false}
            onChange={(e) => onFieldChange(e, Code)}
          />
        );
      case 'dateselection':
        return (
          <DatePicker
            // value={
            value={formObject.InstallationDate}
            // }
            placeholder={`Select ${Name}`}
            format={'YYYY-MM-DD HH:mm:ss'}
            allowClear={false}
            showNow={false}
            showTime={false}
            disabled={formObject.Id && isEditableOnUpdate === 'true' ? true : false}
            onChange={(date) => onFieldChange(date, "InstallationDate")}
            style={{ width: '100%' }}
          />
        );
      case 'multiselect':
        return (
          <SelectComponent
            value={
              formObject && formObject[Code]
                ? formObject[Code]
                : []
            }
            placeholder={`Select ${Name}`}
            Code={props && props.Code ? props.Code : ''}
            formObject={formObject && formObject ? formObject : ''}
            api={JSON}
            DeviceType={deviceType}
            onSelectChange={(e) => onFieldChange(e, Code)}
          />
        );
      default:
        return (
          <InputComponent
            value={
              formObject && formObject[Code]
                ? translation(translationCache, formObject[Code])
                : ''
            }
            placeholder={`Input ${Name}`}
            disabled={formObject.Id && isEditableOnUpdate === 'true' ? true : false}
            onChange={(e) => onFieldChange(e, Code)}
          />
        );
    }
  };


  const cancel = () => {
    // Revert changes by resetting to the original list
    setParameterList(DuplicateList); // Reset editable list to original values
  };
  const onTreeChange = (treeValue) => {
    let { parent } = props;
    const deviceType = findDeviceType(subequipmentListWithParent, treeValue);
    getParameterFileDownloadName(
      parent && parent.Code ? parent.Code : '',
      treeValue,
      deviceType
    );
    getParameterList(treeValue, formObject, deviceType);
    setTreeValue(treeValue);
    setDeviceType(deviceType);
  };
  const findDeviceType = (data, value) => {
    // Iterate over each item in the data array
    for (const item of data) {
      // Check if the current item's value matches the target value
      if (item.value === value) {
        return item.DeviceType; // Return DeviceType if match found
      }

      // If the item has children, recursively search in children
      if (item.children.length > 0) {
        const result = findDeviceType(item.children, value);
        if (result) {
          return result; // Return DeviceType if found in children
        }
      }
    }

    // If no match is found after checking all items and their children
    return null;
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(translationCache, 'Search')}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e ? [e] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, 'Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation(translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
  const columns = [
    {
      title: translation(translationCache, 'Name'),
      dataIndex: 'Name',
      key: 'Name',
      ...getColumnSearchProps('Name')
    },
    {
      title: translation(translationCache, 'Description'),
      dataIndex: 'ParameterDescription',
      key: 'ParameterDescription',
      ...getColumnSearchProps('ParameterDescription'),
      render: (text, record) => {
        if (record.Editable === 'true') {
          return (
            <Input
              value={text}
              onChange={(e) =>
                handleFieldChange(e.target.value, 'ParameterDescription', record.Code)
              }
              onKeyDown={(e) => handleKeyPress(e, record.Code)}
              placeholder={'Description'}
            />
          );
        } else {
          return <div>{text}</div>;
        }
      }
    },
    {
      title: translation(translationCache, 'Edge Code'),
      dataIndex: 'EdgeCode',
      key: 'EdgeCode',
      ...getColumnSearchProps('EdgeCode'),
      render: (text, record) => {
        if (record.Editable === 'true') {
          return (
            <Input
              value={record.EdgeCode}
              onChange={(e) => handleFieldChange(e.target.value, 'EdgeCode', record.Code)}
              onKeyDown={(e) => handleKeyPress(e, record.Code)}
              placeholder={'EdgeCode'}
            />
          );
        } else {
          return <div>{text}</div>;
        }
      }
    },
    {
      title: translation(translationCache, 'Priority'),
      dataIndex: 'Priority',
      key: 'Priority',
      ...getColumnSearchProps('Priority'),
      render: (text, record) => {
        if (record.Editable === 'true') {
          return (
            <Select
              style={{ width: 150 }}
              value={record.Priority}
              onChange={(value) => handleFieldChange(value, 'Priority', record.Code)}
              placeholder={'Priority'}
            >
              {priorityList &&
                Array.isArray(priorityList) &&
                priorityList.map((priority, index) => {
                  return (
                    <Select.Option key={index} value={priority.Value}>
                      {priority.Key}
                    </Select.Option>
                  );
                })}
            </Select>
          );
        } else {
          return <div>{text}</div>;
        }
      }
    },
    {
      title: translation(translationCache, 'Vendor Code'),
      dataIndex: 'VendorCode',
      key: 'VendorCode',
      ...getColumnSearchProps('VendorCode'),
      render: (text, record) => {
        if (record.Editable === 'true') {
          return (
            <Input
              value={record.VendorCode}
              onChange={(e) => handleFieldChange(e.target.value, 'VendorCode', record.Code)}
              onKeyDown={(e) => handleKeyPress(e, record.Code)}
              placeholder={'Vendor Code'}
            />
          );
        } else {
          return <div>{text}</div>;
        }
      }
    },
    {
      title: translation(translationCache, 'Action'),
      key: 'action',
      render: (text, record) => {
        if (record.Editable === 'false') {
          return (
            <span>
              <Button onClick={() => editRow(record.Code, record)}>{'Edit'}</Button>
            </span>
          );
        } else {
          if (record.Editable === 'true') {
            return (
              <span>
                <Button onClick={() => saveRow(record)}>
                  {translation(translationCache, 'Save')}{' '}
                </Button>
                <Divider type="vertical" />
                <Button onClick={(e) => cancel(e, record)}>
                  {translation(translationCache, 'Cancel')}
                </Button>
              </span>
            );
          }
        }
      }
    }
  ];
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  return (
    <Fragment>
      <Tabs
        type="card"
        activeKey={activeKey}
        centered
        onChange={(activeKey) => {
          setActiveKey(activeKey);
        }}
        style={{
          color: 'white'
        }}
      >
        <Tabs.TabPane
          tab={props.ShowForm === 'Device' || props.ShowForm === 'ADD_DEVICE' ? 'Add System' : 'Edit System'}
          key="Device"
        >
          <Form
            name="DeviceForm"
            ref={hRef}
            theme={themeSettings}
            initialValues={formObject}
            layout="horizontal"
            labelCol={{ flex: '130px', marginTop: '20px' }}
            labelAlign="right"
            labelWrap
          >
            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '15px' }}>
              <Form.Item name={'Id'}></Form.Item>
              {props.selectedRow.Type === 'DeviceType' ? null : (
                <Form.Item
                  name="DeviceType"
                  label={translation(translationCache, constant.DeviceTypes)}
                  style={{ width: '50%' }}
                  rules={[{ required: true, message: `Please enter DeviceType!` }]}
                >
                  <Select
                    value={
                      formObject && formObject.DeviceType
                        ? translation(translationCache, formObject.DeviceType)
                        : []
                    }
                    placeholder={`Input ${constant.DeviceTypes}`}
                    disabled={formObject && formObject.Id ? true : false}
                    onChange={(e) => onFieldChange(e, 'DeviceType')}
                  >
                    {deviceTypeList &&
                      Array.isArray(deviceTypeList) &&
                      deviceTypeList.map((devicetype, index) => {
                        return (
                          <Select.Option key={index} value={devicetype.AliasCode}>
                            {devicetype.Name}
                          </Select.Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              )}
              <Form.Item
                name="DisplayCode"
                label={translation(translationCache, constant.DisplayCode)}
                style={{ width: '50%' }}
                rules={[{ required: true, message: `Please enter DisplayCode!` }]}
              >
                <InputComponent
                  value={
                    formObject && formObject.DisplayCode
                      ? translation(translationCache, formObject.DisplayCode)
                      : ''
                  }
                  placeholder={`Input ${constant.DisplayCode}`}
                // onChange={(e) => onFieldChange(e, 'DisplayCode')}
                />
              </Form.Item>
              <Form.Item
                name="UniqueCode"
                style={{ width: '50%' }}
                label={translation(translationCache, constant.Code)}
                rules={[
                  {
                    required: true,
                    message: 'Please input Code!'
                  }
                ]}
              >
                <InputComponent
                  disabled={formObject.Id}
                  placeholder="Input Code!"
                  value={
                    formObject && formObject.UniqueCode
                      ? translation(translationCache, formObject.UniqueCode)
                      : ''
                  }
                />
              </Form.Item>
              <Form.Item
                name="Name"
                label={translation(translationCache, constant.Name)}
                style={{ width: '50%' }}
                rules={[{ required: true, message: `Please enter name!` }]}
              >
                <InputComponent
                  value={
                    formObject && formObject.Name
                      ? translation(translationCache, formObject.Name)
                      : ''
                  }
                  placeholder={`Input ${constant.Name}`}
                // onChange={(e) => onFieldChange(e, 'Name')}
                />
              </Form.Item>
              <Form.Item
                name="Description"
                label={translation(translationCache, constant.Description)}
                style={{ width: '50%' }}
                rules={[{ required: true, message: `Please enter Description!` }]}
              >
                <Input.TextArea
                  placeholder={`Input ${constant.Description}`}
                  value={
                    formObject && formObject.Description
                      ? translation(translationCache, formObject.Description)
                      : ''
                  }
                // onChange={(e) => onFieldChange(e, 'Description')}
                />
              </Form.Item>

              {attributeList &&
                Array.isArray(attributeList) &&
                attributeList.map((attr, key) => {
                  let requiredField = attr && attr.mandatory === 'Optional' ? false : true;
                  return (
                    <Form.Item
                      key={key}
                      name={attr.Code}
                      label={translation(translationCache, attr.Name)}
                      style={{ width: '50%' }}
                      rules={[{ required: requiredField, message: `Please enter ${attr.Name}!` }]}
                    >
                      {renderWidget(attr, formObject)}
                    </Form.Item>
                  );
                })}
            </div>

            <Form.Item {...{ wrapperCol: { offset: 5, span: 16 } }}>
              <Space>
                {props.ShowForm === 'Device' || props.ShowForm === 'ADD_DEVICE' ? (
                  <Button type="primary" onClick={onCreate}>
                    Create
                  </Button>
                ) : (
                  <Button type="primary" onClick={onCreate}>
                    Update
                  </Button>
                )}
                <Button htmlType="button" onClick={onReset}>
                  Reset
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Tabs.TabPane>

        {props.ShowForm === 'EDIT_DEVICE' && formObject && formObject.Id ? (
          <Tabs.TabPane tab="Sub Equipments" key="SubEquipments">
            <SubEquipments
              selectedRow={props.selectedRow}
              treeValue={treeValue}
              ShowForm={props.ShowForm}
              translationCache={translationCache}
              Module={props.Module}
              parent={props.parent}
              deviceDetails={formObject}
              updateParentDataFromSUbEqpChange={updateParentDataFromSUbEqpChange}
            />
          </Tabs.TabPane>
        ) : null}
        {props.ShowForm === 'EDIT_DEVICE' && formObject && formObject.Id ? (
          <Tabs.TabPane tab="Parameters" key="parameter">
            <>
              <div style={{ margin: '10px 0px' }}>
                <Form
                  name="DeviceForm"
                  // ref={hRef}
                  theme={themeSettings}
                  initialValues={formObject}
                  layout="horizontal"
                  labelCol={{ flex: '250px', marginTop: '20px' }}
                  labelAlign="right"
                  labelWrap
                >
                  <Form.Item
                    label={translation(translationCache, constant.SELECTPARENT_equipment)}
                    style={{ width: '50%' }}
                    rules={[{ required: false }]}
                  >
                    <TreeSelect
                      showSearch
                      style={{ width: '100%' }}
                      value={treeValue}
                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                      placeholder={constant.SELECTPARENT_equipment}
                      allowClear={false}
                      treeDefaultExpandAll
                      onChange={onTreeChange}
                      treeData={subequipmentListWithParent}
                    />
                  </Form.Item>
                </Form>
                {(parameterFileName && parameterFileName !== undefined) ||
                  (parameterFileName && parameterFileName !== '') ? (
                  <div style={{ display: 'flex', justifyContent: 'right' }}>
                    <a href={`${IPAddress.LOCAL}${parameterFileName}`}>
                      <DownloadOutlined
                        style={{ color: 'white', marginRight: '6px' }}
                      />
                      <span style={{ color: 'white' }} disabled={true}>
                        Download{' '}
                      </span>
                    </a>
                    <Upload
                      multiple={false}
                      style={{ marginRight: '10px', color: 'white' }}
                      onChange={(info) => {
                        if (info.file.status === 'done') {
                          message.success(info.file.response.message);

                          // getParameterList(treeValue, formObject);
                          getParameterList(treeValue, deviceType);

                          getParameterFileDownloadName(
                            props.parent && props.parent.Code
                              ? props.parent.Code
                              : '',
                            treeValue,
                            deviceType
                          );
                        } else if (info.file.status === 'error') {
                          message.error(info.file.response.message);
                        }
                      }}
                      action={`${UPLOAD.CLIENT_Upload_Parameter}?SiteId=${siteId}&DeviceType=${deviceType && deviceType !== undefined
                        ? deviceType
                        : props.parent && props.parent.Code
                        }&DeviceAlias=${treeValue}`}
                      headers={{
                        Authorization: Authorization
                      }}
                      showUploadList={false}
                    >
                      <UploadOutlined
                        style={{ color: 'white', marginRight: '1px' }}
                      />
                      <span style={{ color: 'white', marginRight: '10px' }}> Upload </span>
                    </Upload>
                  </div>
                ) : null}
              </div>
              <StyledTable size="small"
                loading={loading}
                columns={columns}
                dataSource={parameterList && Array.isArray(parameterList) ? parameterList : null}
              />
            </>
          </Tabs.TabPane>
        ) : null}
      </Tabs>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(Device);
